import angular from "angular";

angular.module('ui-sentinel.devicegroups', [
    'api-sentinel'
]);
